<template>
  <div class="contents">
    <div class="container-fluid">
      <div class="breadcrumb-main user-member justify-content-sm-between mb-3">
        <h4 class="text-capitalize fw-500 breadcrumb-title">
          <router-link :to="'/shop/' + shopId + '?tab=produk'"><i class="fas fa-arrow-left"></i></router-link>
          &nbsp; Daftar Siswa / Enrollment
        </h4>
      </div>

      <div class="row mb-3" v-if="stats">
        <div class="col-md-4"><div class="card p-3 border"><small>Total Kursus</small><h4>{{ stats.total_courses }}</h4></div></div>
        <div class="col-md-4"><div class="card p-3 border"><small>Total Enrollment</small><h4>{{ stats.total_count }}</h4></div></div>
        <div class="col-md-4"><div class="card p-3 border"><small>Pendapatan Kursus</small><h4 class="text-primary">{{ formatRupiah(stats.total_amount) }}</h4></div></div>
      </div>

      <div class="card p-3 border bg-white radius-xl mb-3">
        <div class="row">
          <div class="col-md-4">
            <select v-model="filterStatus" class="form-control" @change="load">
              <option value="">Semua Status</option>
              <option value="pending">Pending</option>
              <option value="paid">Paid</option>
            </select>
          </div>
        </div>
      </div>

      <div class="card p-3 border bg-white radius-xl">
        <div v-if="loading" class="text-center p-4"><div class="spinner-border"></div></div>
        <table v-else class="table table-sm">
          <thead>
            <tr>
              <th>Tanggal</th><th>Kursus</th><th>Siswa</th><th>Progress</th><th>Total</th><th>Status</th><th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="e in enrollments" :key="e.id">
              <td><small>{{ formatTime(e.created_at) }}</small></td>
              <td>{{ e.course_title || '-' }}</td>
              <td>{{ e.student_name || '-' }}<br><small class="text-muted">{{ e.student_phone }}</small></td>
              <td>{{ e.progress_pct || 0 }}%</td>
              <td>{{ formatRupiah(e.amount) }}</td>
              <td><span class="badge" :class="e.payment_status === 'paid' ? 'badge-success' : 'badge-warning'">{{ e.payment_status }}</span></td>
              <td>
                <button v-if="e.payment_status === 'pending'" class="btn btn-sm btn-success" @click="markPaid(e.id)">Mark Paid</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shopId: null,
      enrollments: [],
      stats: null,
      filterStatus: '',
      loading: false,
    };
  },
  mounted() {
    this.shopId = parseInt(this.$route.params.id);
    this.loadStats();
    this.load();
  },
  methods: {
    formatRupiah(v) { return 'Rp ' + (v || 0).toLocaleString('id-ID'); },
    formatTime(ms) { return ms ? new Date(ms).toLocaleString('id-ID') : '-'; },
    async loadStats() {
      try {
        const r = await this.$store.dispatch('shop_lms/lms_stats', this.shopId);
        this.stats = r.data.data;
      } catch (e) { /* noop */ }
    },
    async load() {
      this.loading = true;
      try {
        const params = {};
        if (this.filterStatus) params.payment_status = this.filterStatus;
        const r = await this.$store.dispatch('shop_lms/lms_list_enrollments', { shopId: this.shopId, params });
        this.enrollments = r.data.data.enrollments || [];
      } finally { this.loading = false; }
    },
    async markPaid(id) {
      if (!confirm('Tandai enrollment ini sudah dibayar?')) return;
      try {
        await this.$store.dispatch('shop_lms/lms_mark_paid', id);
        this.$toast.success('Enrollment ditandai paid');
        this.load();
        this.loadStats();
      } catch (e) {
        this.$toast.error(e.response?.data?.message || 'Gagal');
      }
    },
  },
};
</script>
